const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M4 11.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm10 0a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
